import React from 'react';
import * as S from './InputErrorMessage.styles';
const InputErrorMessage = /*#__PURE__*/React.forwardRef(({
  children,
  orientation
}, ref) => {
  return /*#__PURE__*/React.createElement(S.InputErrorMessageContainer, {
    $isHorizontal: orientation === 'horizontal'
  }, /*#__PURE__*/React.createElement(S.ErrorIcon, null), /*#__PURE__*/React.createElement(S.InputErrorMessageRoot, {
    variant: "ui",
    size: "small",
    ref: ref
  }, children));
});
export { InputErrorMessage };